import type { FaireProductEntity } from "../../entity_types/product";

export const p_6sy6atfkhp: FaireProductEntity = {
  token: "p_6sy6atfkhp",
  type: "product",
  name: "Beef Tallow Potato Chips - Barbecue",
  brandToken: "b_d6aqh4qdhb",
  brandName: "Beefy's Own",
  imageUrl:
    "https://cdn.faire.com/fastly/ac9cd269f523e99a91207010bffa24065a9149f75365eb1027a9cb9f561b8e6d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2cd92921cb342063d2caf822cd69b3b5426d34f900f4a9310df55cb734443876.png",
    "https://cdn.faire.com/fastly/1d90c979034b654bbc78880d9f5e15610c142576ab7fe017f392d10e34e9c850.png",
    "https://cdn.faire.com/fastly/4e9a64fe544d1eaf7f38327e0b6d8d4c2e8619707528e0739670229bb40edf73.png",
    "https://cdn.faire.com/fastly/52f7ea194e65b82d7605ee6edbf9007e939b3b0a7693d6da6b2fecd0acaefa5d.png",
    "https://cdn.faire.com/fastly/4f67585a9615d03f5ba85e0b26dba4ddcc6fa656f23091e182ad64b142fd21ea.png",
    "https://cdn.faire.com/fastly/2a500532396aaebecbc3052c07c89f5631fe214930417f5a6ae0f50f1439f89c.png",
    "https://cdn.faire.com/fastly/a2443601c530194433797ec7c9cf6bfc8d8f554492b84012dc16a4afec2d636f.png",
  ],
  priceDollars: 6.5,
  description:
    "Perfect, crispy, golden potato chips fried the old-fashioned way in pure beef tallow — bringing back old-school flavor you forgot existed. Our BBQ chips hit with that sweet-and-smoky magic - inspired by Kansas City-style barbecue and crafted for perfect balance. You get subtle sweetness, a mellow kick of spice, and a savory depth that only beef tallow can bring. Our dedicated team of chip artisans takes pride in ensuring every chip meets the highest standards of taste and texture. From the satisfying crunch to the perfectly seasoned finish, these small-batch chips deliver a snack experience like no other.\n\n-5oz bags-\nNon-GMO Potatoes, Beef Tallow, Date Sugar, Onion Powder, Sea Salt, Tomato Powder, Garlic Powder, Paprika, Chili Powder, White Distilled Vinegar, Smoked Paprika.",
  tags: [],
  msrpDollars: 9.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T21:11:38.485Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
